import styled from 'styled-components'

const FullWidthStyle = styled.div`
	--fileHeight: 50%;

	margin-top: var(--sectionsDistance);

	&.imageMarginSize {
		margin-top: var(--bannerDistance);
	}

	.imageCont,
	.videoCont {
		--proportion: var(--fileHeight);
        
		width: 100%;
	}

	.videoWrapper {
		.videoIcons {
            pointer-events: none;
			display: none;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeL}) {
		/* --fileHeight: 50%; */
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		/* --fileHeight: 50%; */
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		/* --fileHeight: 50%; */
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		/* --fileHeight: 50%; */
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		/* --fileHeight: 50%; */
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSizeS}) {
		/* --fileHeight: 50%; */

		.videoWrapper {
			position: relative;

			i {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 1111;
				opacity: 1;
				transition: all var(--trTimeS) ease;
				mix-blend-mode: difference;

				&:before {
					color: var(--white);
					font-size: var(--hoverVideoIconSize);
				}

				&.bb-pause {
					opacity: 0;
				}
			}

			&:hover {
				.bb-pause {
					opacity: 1;
				}
			}

			.videoIcons {
				display: block;
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--fileHeight: 82%;

		.videoWrapper {
			position: relative;

			i {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 1111;
				opacity: 1;
				transition: all var(--trTimeS) ease;
				mix-blend-mode: difference;

				&:before {
					color: var(--white);
					font-size: var(--hoverVideoIconSize);
				}

				&.bb-pause {
					opacity: 0;
				}
			}

			&:hover {
				.bb-pause {
					opacity: 1;
				}
			}

			.videoIcons {
				display: block;
			}
		}
	}

	/* IPad */
	/* Landscape */
	@media only screen and (min-device-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) and (max-device-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
		.videoWrapper {
			position: relative;

			i {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				z-index: 1111;
				opacity: 1;
				transition: all var(--trTimeS) ease;
				mix-blend-mode: difference;

				&:before {
					color: var(--white);
					font-size: var(--hoverVideoIconSize);
				}

				&.bb-pause {
					opacity: 0;
				}
			}

			&:hover {
				.bb-pause {
					opacity: 1;
				}
			}

			.videoIcons {
				display: block;
			}
		}
	}
`

export default FullWidthStyle
